var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoYoutubeWhite(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "18px",
    viewBox: "0 0 26 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo_youtube") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo_youtube",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.0144839,2.81075806 C25.5483871,4.81601613 25.5483871,9 25.5483871,9 C25.5483871,9 25.5483871,13.1838387 25.0144839,15.1892419 C24.7206774,16.2956613 23.8549355,17.1669194 22.755629,17.4627581 C20.7634355,18 12.7741935,18 12.7741935,18 C12.7741935,18 4.78495161,18 2.7926129,17.4627581 C1.69330645,17.1669194 0.827564516,16.2956613 0.533758065,15.1892419 C0,13.1838387 0,9 0,9 C0,9 0,4.81601613 0.533758065,2.81075806 C0.827564516,1.70433871 1.69330645,0.833080645 2.7926129,0.537387097 C4.78495161,0 12.7741935,0 12.7741935,0 C12.7741935,0 20.7634355,0 22.755629,0.537387097 C23.8549355,0.833080645 24.7206774,1.70433871 25.0144839,2.81075806 Z M10.1612468,12.7987403 L16.8386661,9.00015968 L10.1612468,5.20128871 L10.1612468,12.7987403 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoYoutubeWhite);
export default __webpack_public_path__ + "static/media/logo_youtube_white.8bdeac177bd35bd7aa7c7ab989349126.svg";
export { ForwardRef as ReactComponent };